import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaUsers, FaCheck, FaAward } from "react-icons/fa";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import "./services.css";

const services = [
  {
    title: "Build Fast. Launch Smart.",
    desc: "We turn your ideas into working products fast. From first sketch to final release, we handle the full tech stack so you can focus on growth.",
  },
  {
    title: "MVPs That Get Traction",
    desc: "We help startups validate ideas quickly with lean, testable MVPs that attract users, feedback, and funding.",
  },
  {
    title: "AI & Automation for Scale",
    desc: "We plug in AI and automation where it matters-boosting efficiency, cutting costs, and helping you scale without the overhead.",
  },
  {
    title: "Tech Strategy That Makes Sense",
    desc: "We're not just coders-we're your tech co-founders. Our domain-driven advice helps you make smart decisions early and often.",
  },
  {
    title: "Design That Converts",
    desc: "Our UI/UX isn't just pretty-it's built to drive engagement, retention, and revenue.",
  },
];

const WhatWeDo = () => {
  return (
    <div className="what-we-do">
      <section className="stats-section container">
        <Container fluid className="service-section">
          <Row className="g-0">
            <Col lg={4} md={4}>
              <div className="stat-card gradient-bg">
                <div className="stat-icon">
                  <FaUsers />
                </div>

                <div>
                  <h5>Client Retention Rate</h5>
                  <h2>
                    <CountUp end={4.9} decimals={1} duration={3} />
                  </h2>
                </div>
              </div>
            </Col>

            <Col lg={4} md={4}>
              <div className="stat-card light-bg">
                <div className="stat-icon purple">
                  <FaCheck />
                </div>

                <div>
                  <h5>Innovation Delivered</h5>
                  <h2>
                    <CountUp end={120} duration={3} />
                  </h2>
                </div>
              </div>
            </Col>

            <Col lg={4} md={4}>
              <div className="stat-card gradient-bg">
                <div className="stat-icon">
                  <FaAward />
                </div>

                <div>
                  <h5>Cloud Solutions Delivered</h5>
                  <h2>
                    <CountUp end={350} duration={3} />
                  </h2>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="what-we-do-section">
        <Container>
          <div className="section-title ">
            <h2 className="gradient-text">WHAT WE DO</h2>
            <div className="title-line"></div>
          </div>

          <Row className="justify-content-center g-4">
            {services.map((item, index) => (
              <Col lg={4} md={6} key={index}>
                <motion.div
                  className="service-card"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.1,
                  }}
                  viewport={{ once: true }}
                  whileHover={{
                    y: -8,
                  }}
                >
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default WhatWeDo;
